import { render, staticRenderFns } from "./LabelProduct.vue?vue&type=template&id=085512f0&scoped=true"
import script from "./LabelProduct.vue?vue&type=script&lang=js"
export * from "./LabelProduct.vue?vue&type=script&lang=js"
import style0 from "./LabelProduct.vue?vue&type=style&index=0&id=085512f0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085512f0",
  null
  
)

export default component.exports